// Ajaxing SVG sprite

import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class GoBack extends WebComponent {
  constructor(props) {
    super(props);
    this.handleGoBack = this.handleGoBack.bind(this);
  }
  didMount() {
    this.element.addEventListener('click', this.handleGoBack)
  }
  handleGoBack(e) {
    e.preventDefault();
    console.log(window.projectConfig.lang);
    if (document.referrer == '' || window.history.length === 1) {
      window.projectConfig.lang === 'cs' ? window.location.href = '/cs' : window.location.href = '/en';
    } else {
      window.history.back();
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoBack.js